import theme from '@/theme';
import { CropMode } from '@/utils/types';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';

interface Props {
    cropMode: CropMode;
}

export const VideoSkeleton = styled(Skeleton)<{ cropMode: CropMode }>`
    height: 100%;
    border-radius: 12px;
    transform: scale(1);
    aspect-ratio: ${({ cropMode }) => (cropMode === CropMode.Wide ? '16 / 9' : cropMode === CropMode.Square ? '1 / 1' : '9 / 16')};
    background-color: ${theme.colors.black[300]};
`;

export const SceneTileSkeleton = styled(Skeleton)<{ cropMode: CropMode }>`
    height: 100px;
    border-radius: 8px;
    transform: scale(1);
    aspect-ratio: ${({ cropMode }) => (cropMode === CropMode.Wide ? '16 / 9' : cropMode === CropMode.Square ? '1 / 1' : '9 / 16')};
    background-color: ${theme.colors.black[100]};
`;

const VideoSkeletonContainer = styled.div`
    height: calc(100% - 170px - 48px);
    width: 100%;
    display: flex;
    justify-content: center;

    border-radius: 14px;
    padding: 24px;
    background-color: ${theme.colors.black[100]};
    box-sizing: border-box;
`;

const ContentBarSkeleton = styled.div`
    display: flex;
    gap: 8px;
    padding: 0px 24px;
    overflow: hidden;
`;

export const TemplateGalleryScenesSkeleton = ({ cropMode }: Props) => {
    return (
        <ContentBarSkeleton>
            <SceneTileSkeleton cropMode={cropMode} />
            <SceneTileSkeleton cropMode={cropMode} />
            <SceneTileSkeleton cropMode={cropMode} />
        </ContentBarSkeleton>
    );
};

export const TemplateGalleryPreviewSkeleton = ({ cropMode }: Props) => {
    return (
        <>
            <VideoSkeletonContainer>
                <VideoSkeleton cropMode={cropMode} />
            </VideoSkeletonContainer>
            <TemplateGalleryScenesSkeleton cropMode={cropMode} />
        </>
    );
};
